<!-- Copyright © 2026 Xerox Corporation. All Rights Reserved. Copyright protection claimed includes all forms and matters of copyrightable material and information now allowed by statutory or judicial law or hereinafter granted, including without limitation, material generated from the software programs which are displayed on the screen such as icons, screen display looks, etc. -->

@for (item of list; track item) {
  <div class="cb" [id]="id" [ngClass]="display">
    <div class="xrx-radio" (click)="!item.disabled && onChecked(item)">
      <label
        [for]="getPropertyString('property', item)"
        [ngClass]="{ disabled: item.disabled }"
        [xdaTranslate]="getPropertyString('localize', item)"></label>
      <div
        class="radio"
        [ngClass]="{
          checked:
            getPropertyString('property', item) ===
            getPropertyString('property', checkedItem),
          disabled: item.disabled,
        }">
        <span class="icons">
          <span
            class="first-icon xgl-radio_off glyph-chbx-radio-theme-uchkd"></span>
          <span
            class="second-icon xgl-radio_on glyph-chbx-radio-theme-chkd"></span>
        </span>
      </div>
    </div>
    @if (xrxRadioTemplateRef && checkedItem.value == item.value) {
      <div class="xrx-radio-content">
        <ng-container [ngTemplateOutlet]="xrxRadioTemplateRef"> </ng-container>
      </div>
    }
    @if (getPropertyString('desc', item)) {
      <div class="description">
        <span [xdaTranslate]="getPropertyString('desc', item)"></span>
      </div>
    }
  </div>
}
